<template>
  <quill-editor
    class="task-form-quill-editor"
    :content="content"
    :options="options"
    :disabled="disabled"
    @change="change"/>
</template>

<script>
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

import '@components/vue-quill-editor/formats/font'
import { quillEditor } from 'vue-quill-editor'

export default {
  components: {QuillEditor: quillEditor},
  props: {
    value: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      options: {
        bounds: $('#main')[0],
        placeholder: this.placeholder,
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [
              {
                'list': 'ordered',
              },
              {
                'list': 'bullet',
              },
            ],
            [{'header': [1, 2, 3, 4, 5, 6, false]}],
            ['blockquote'],
            [
              {'color': ['#f3605b', '#333']},
              {'background': ['#f3605b', '#333']}
            ],
            ['link'],
            [{'align': []}],
            ['clean'],
          ],
        },
      }
    }
  },
  computed: {
    content: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      },
    }
  },
  watch: {},
  created () {},
  mounted () {},
  updated () {},
  destroyed () {},
  methods: {
    change ({editor, html, text}) {
      if (this.content !== html) {
        this.content = html
      }
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
.task-form-quill-editor {
  background-color: white;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  overflow: hidden;
  width: 100%;

  &:hover {
    border-color: #c0c4cc;
  }

  .ql-container {
    font-size: inherit;
  }

  .ql-container.ql-snow {
    background-color: white;
    box-sizing: border-box;
    border: none;
    width: 100%;
    min-height: inherit;

    .ql-editor {
      min-height: inherit;
    }
  }

  .ql-toolbar.ql-snow {
    background-color: white;
    padding: 5px 15px;
    box-sizing: border-box;
    width: 100%;
    border: none;
    border-bottom: 1px solid #dcdfe6;
    // 覆盖 .el-form-item__label 的 line-height
    line-height: 24px !important;
  }
}
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/task/components/TaskFormQuillEditor.vue